import { useValue } from '@morningtrain/react-resources'
import { useTranslation } from '@morningtrain/react-translations'

export default function Duration ({ name, fromSeconds = false, fromMinutes = false }) {
  const value = useValue(name)

  const hoursString = useTranslation('generic.time_single.hours')
  const minutesString = useTranslation('generic.time_single.minutes')
  const secondsString = useTranslation('generic.time_single.seconds')

  let factor = 1
  if (fromSeconds === true) {
    factor = 3600
  } else if (fromMinutes) {
    factor = 60
  }

  const valueInHours = value / (fromSeconds === false ? 1 : factor)

  const hours = Math.abs(parseInt(valueInHours))
  const subHours = Math.abs(valueInHours) - hours

  const minutes = parseInt(subHours * 60)
  const seconds = parseInt(subHours - (minutes * 60))

  if (valueInHours === 0) {
    return 0 + minutesString
  }

  return [
    valueInHours < 0 ? '-' : '',
    hours > 0 ? hours + hoursString : 0,
    minutes > 0 ? minutes + minutesString : 0,
    seconds > 0 ? seconds + secondsString : 0
  ].filter(v => v).join(' ')
}
